import axios from 'axios';
const BaseUrl = process.env.VUE_APP_WEI;
export const requestWei = axios.create({
  baseURL: BaseUrl,
  timeout: 10000,
  withCredentials: false,
});
// requestWei.interceptors.request.use(
//   function (config) {
//     let postdata = {
//       ua: ua,
//       args: {},
//       sign: {},
//       timestamp: '1642664673',
//     };
//     const { call } = config.data;
//     let args = JSON.stringify(config.data.args);


//     let str = `${signKey}${call}${signKey}${args}${signKey}`;
//     let sign = md5(str);
//     postdata.sign = sign;
//     postdata = Object.assign(postdata, config.data);
//     delete postdata.call;
//     config.data = postdata;

//     let REPORTTOKEN = localStorage.getItem('REPORT_TOKEN');
//     let REPORTAPP = localStorage.getItem('REPORT_APP');
//     let appName = sessionStorage.getItem('app_name');
//     let utm_source = getQueryString('utm_source') || sessionStorage.getItem('utm_source')
//     let arms_uid = localStorage.getItem('SESSIONTOKEN') ;
//     if(arms_uid){
//       config.headers['arms-uid'] = arms_uid + getQueryString('type');
//     }
//     if (appName) {
//       config.headers['App-Name'] = appName;
//       config.headers['app'] = appName;
//       config.headers['inner-app'] = appName;
//     }
//     if (utm_source) {
//       config.headers['utm-source'] = utm_source;
//     }
//     if (REPORTTOKEN) {
//       config.headers.Token = REPORTTOKEN;
//     }
//     if (REPORTAPP) {
//       config.headers['App-Name'] = REPORTAPP;
//       config.headers['app'] = REPORTAPP;
//       config.headers['inner-app'] = REPORTAPP;
//     }

//     return config;
//   },
//   function (error) {
//     // 对请求错误做些什么
//     return Promise.reject(error);
//   }
// );

requestWei.interceptors.response.use(
  response => {
    return response.data;
  },
  error => Promise.reject(error)
);